import { render, staticRenderFns } from "./Resource.vue?vue&type=template&id=f5a9d0d2&"
import script from "./Resource.vue?vue&type=script&lang=js&"
export * from "./Resource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/miryamfv/Proyectos/valet/dz0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5a9d0d2')) {
      api.createRecord('f5a9d0d2', component.options)
    } else {
      api.reload('f5a9d0d2', component.options)
    }
    module.hot.accept("./Resource.vue?vue&type=template&id=f5a9d0d2&", function () {
      api.rerender('f5a9d0d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/Resource.vue"
export default component.exports